import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { _StageCardHeader } from "./style";
import StageSummary from "./StageSummary";
var StageCardHeader = function StageCardHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    toggleExpand = _ref.toggleExpand,
    expanded = _ref.expanded,
    preview = _ref.preview,
    stageEmpty = _ref.stageEmpty,
    statusCounts = _ref.statusCounts,
    headingId = _ref.headingId;
  return /*#__PURE__*/React.createElement(_StageCardHeader, {
    preview: preview,
    stageEmpty: stageEmpty
  }, /*#__PURE__*/React.createElement("div", {
    className: "stage-card-title"
  }, /*#__PURE__*/React.createElement("h4", {
    id: headingId
  }, title), !preview && /*#__PURE__*/React.createElement("span", null, subtitle)), /*#__PURE__*/React.createElement("div", {
    "walkme-id": "requirements-documentstatus",
    className: "stage-card-summary"
  }, !preview && /*#__PURE__*/React.createElement(StageSummary, _extends({
    title: title
  }, statusCounts)), !stageEmpty &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  React.createElement("div", {
    className: "expand-button",
    onClick: toggleExpand
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: expanded ? 'minus' : 'plus'
  }))));
};
StageCardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  preview: PropTypes.bool,
  expanded: PropTypes.bool,
  statusCounts: PropTypes.object,
  toggleExpand: PropTypes.func
};
StageCardHeader.defaultProps = {
  preview: false
};
export default StageCardHeader;